import { getOutboundMessage } from './outboundUtils';
export function createDirectMessageOutbound(playerId, message) {
    return getOutboundMessage({
        _type: 'private_msg',
        parts: [
            { name: 'playerId', numberValue: playerId },
            { name: 'message', stringValue: message, needsEncoding: true }
        ]
    });
}
/**
 * Fetches the entire message log with a player (beforeMessageId is always -1 to indicate all recent message history)
 * which may include some 'unread' messages that will be colored in the returned HTML.
 */
export function createRequestDirectMessagesLogOutbound(playerId) {
    return getOutboundMessage({
        _type: 'private_msgs_log',
        parts: [
            { name: 'playerId', numberValue: playerId },
            { name: 'beforeMessageId', numberValue: -1 }
        ]
    });
}
/**
 * Private messages should be marked as read in these scenarios:
 * - when the private messages log for a given conversation is fetched and displayed
 * - when a conversation that's already visible receives more messages, mark as read if the user clicks the mouse or a keyboard key
 * - when opening messages from a notification toast for an active conversation that has previously been fetched, but has additional messages not marked as read
 * - when switching to the messages panel for an active conversation that has previously been fetched, but has additional messages not marked as read
 */
export function createDirectMessagesReadOutbound(playerId, lastUnreadMessageId) {
    return getOutboundMessage({
        _type: 'private_msgs_read',
        parts: [
            { name: 'playerId', numberValue: playerId },
            { name: 'lastUnreadMessageId', numberValue: lastUnreadMessageId }
        ]
    });
}
export function createDirectMessagesRecentOutbound() {
    return getOutboundMessage({
        _type: 'get_private_msgs_recent'
    });
}
